import React from "react";
import Breadcrumb from "../components/Breadcrumb";

export default function SocialMediaManagement() {
  return (
    <>
      <Breadcrumb title="Social Media Management" />

      <div className="page-service-single">
        <div className="container">
          {/* Main Content */}
          <div className="row">
            <div className="col-lg-12">
              <div className="service-single-content">
                {/* Featured Image */}
                <div className="service-featured-image">
                  <figure className="image-anime reveal">
                    <img
                      src="/assets/images/socialmedia.png"
                      alt="Social Media Management"
                      loading="lazy"
                    />
                  </figure>
                </div>

                {/* Entry Content */}
                <div className="service-entry">
                  <p className="wow fadeInUp" data-wow-delay="0.25s">
                    We manage and grow your social media presence with
                    compliant, engaging, and performance-focused strategies. Our
                    approach balances brand storytelling with measurable results
                    across platforms.
                  </p>

                  <h4 className="mb-2">What we do</h4>
                  <ul>
                    <li>Social media strategy & content planning</li>
                    <li>Social & web content creation</li>
                    <li>Paid social campaigns & influencer marketing</li>
                    <li>Community management & performance analytics</li>
                  </ul>

                  <h4 className="mb-2 mt-2">Value we create</h4>
                  <ul>
                    <li>Stronger audience engagement</li>
                    <li>Consistent brand voice</li>
                    <li>Higher reach, leads & conversions</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Service Blocks */}
          <div className="row">
            <ServiceBlock
              title="Account & Page Management"
              items={[
                "Profile setup & optimization",
                "Brand tone & visual consistency",
                "Bio, cover & highlight updates",
              ]}
            />

            <ServiceBlock
              title="Scheduling & Publishing"
              items={[
                "Weekly & monthly scheduling",
                "Content calendar planning",
                "Cross-platform automation",
              ]}
            />

            <ServiceBlock
              title="Monitoring & Engagement"
              items={[
                "Comment & message management",
                "Lead routing & inbox handling",
                "Community interaction",
                "Crisis monitoring & social listening",
              ]}
            />

            <ServiceBlock
              title="Community Building"
              items={[
                "Group & community management",
                "Hashtag engagement",
                "Stakeholder & partner networking",
              ]}
            />

            <ServiceBlock
              title="Analytics & Optimization"
              items={[
                "Monthly analytics reports",
                "Reach, clicks & growth tracking",
                "Competitor benchmarking",
                "Optimization recommendations",
              ]}
            />

            <ServiceBlock
              title="Graphic Content"
              items={[
                "Static posts & banners",
                "Carousel & infographic designs",
                "Product & website visuals",
              ]}
            />

            <ServiceBlock
              title="Video Content"
              items={[
                "Reels, shorts & vertical videos",
                "Corporate promos & demos",
                "Motion graphics & animations",
              ]}
            />

            <ServiceBlock
              title="Written Content"
              items={[
                "Captions, hashtags & CTAs",
                "Blogs & landing pages",
                "Email & product copy",
              ]}
            />

            <ServiceBlock
              title="Paid Media Campaigns"
              items={[
                "Meta, LinkedIn & YouTube Ads",
                "Retargeting & lookalike audiences",
                "Conversion tracking & optimization",
              ]}
            />

            <ServiceBlock
              title="Influencer Marketing"
              items={[
                "Influencer discovery",
                "Collaboration management",
                "Campaign execution & tracking",
              ]}
            />
          </div>
        </div>
      </div>
    </>
  );
}

/* ✅ Reusable Service Block */
function ServiceBlock({ title, items }) {
  return (
    <div className="col-lg-4">
      <div className="service-sidebar">
        <div className="services-list-box wow fadeInUp" data-wow-delay="0.5s">
          <h3>{title}</h3>
          <ul>
            {items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
